export interface AdminCampaignSummary {
  campaignId: number;
  name: string | null;
  type: string | null;
  currentState: string | null;
  generationStatus: string | null;
  ownerEmail: string | null;
  ownerName: string | null;
  adName: string | null;
  createDateTime: string | null;
  /** Campaign-level aggregated measured reach (JSON document), or null if not yet computed. */
  measuredReach?: string | null;
  runsTotal: number;
  runsInProgress: number;
  runsPaused: number;
  runsPendingApproval: number;
  runsCompleted: number;
}

export interface AdminCampaignRun {
  runId: number;
  campaignId: number | null;
  campaignName: string | null;
  state: string | null;
  approvalState: string | null;
  scheduledStartAt: string | null;
  scheduledEndAt: string | null;
  approvalDeadline: string | null;
  /** Populated by the schedule run-calendar endpoint; null elsewhere. */
  driverProfileId?: number | null;
  driverName: string | null;
  progressPercentage: number | null;
  distanceTraveledMeters: number | null;
  pauseReason: string | null;
  pausedAt: string | null;
  abortReason: string | null;
  createdAt: string | null;
  /** Per-run measured reach (JSON document), or null until the run has been analyzed. */
  measuredReach?: string | null;
}

export interface AdminCampaignDetail {
  summary: AdminCampaignSummary;
  runs: AdminCampaignRun[];
}

/** Result of POST /api/admin/campaigns/{id}/measured-reach/recompute. */
export interface RecomputeMeasuredReachResult {
  campaignId: number;
  completedRuns: number;
  triggered: number;
  skippedNoGps: number;
  failed: number;
}

/** Result of PATCH /api/admin/campaigns/{campaignId}/runs/{runId} (subset of CampaignRunSummaryDto). */
export interface RescheduleRunResult {
  runId: number;
  slotStart: string | null;
  slotEnd: string | null;
  approvalState: string | null;
  approvalDeadline: string | null;
  assignedDriverDisplayName: string | null;
}

/** Mirrors apiserver CampaignState (spec.request.ad.CampaignState). */
export const CAMPAIGN_STATES = [
  'DRAFT',
  'SCHEDULED',
  'ACTIVE',
  'COMPLETED',
  'PARTIALLY_COMPLETE',
  'NEEDS_RUNS',
  'STOPPED_BY_OWNER'
] as const;
